import { Box, Stack, Typography, Tooltip } from '@mui/material';
import { Twitter as TwitterIcon, YouTube as YouTubeIcon, Instagram as InstagramIcon } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

const AuthFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        maxWidth: { xs: '100%', md: '85%' },
        mx: 'auto',
      }}
    >
      {/* Footer content - single row layout */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        width: '100%'
      }}>
        {/* Copyright */}
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem', opacity: 0.6 }}>
          {currentYear} CoinFox - {t('common.allRightsReserved')}
        </Typography>

        {/* Social Media Icons */}
        <Stack direction="row" spacing={1.5}>
          <Tooltip title={t('common.comingSoon')} arrow placement="top">
            <Box 
              component="span" 
              aria-label="Twitter" 
              sx={{ color: 'text.secondary', opacity: 0.6, cursor: 'pointer', '&:hover': { opacity: 1 } }}
            >
              <TwitterIcon fontSize="small" />
            </Box>
          </Tooltip>
          <Tooltip title={t('common.comingSoon')} arrow placement="top">
            <Box 
              component="span" 
              aria-label="YouTube" 
              sx={{ color: 'text.secondary', opacity: 0.6, cursor: 'pointer', '&:hover': { opacity: 1 } }}
            >
              <YouTubeIcon fontSize="small" />
            </Box>
          </Tooltip>
          <Tooltip title={t('common.comingSoon')} arrow placement="top">
            <Box 
              component="span" 
              aria-label="Instagram" 
              sx={{ color: 'text.secondary', opacity: 0.6, cursor: 'pointer', '&:hover': { opacity: 1 } }}
            >
              <InstagramIcon fontSize="small" />
            </Box>
          </Tooltip>
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthFooter;
